import React, { useState } from "react";

import Container from "@mui/material/Container";

import { makeStyles } from "@mui/styles";

import SearchOptions from "./SearchOptions";
import PlayerSessionsTable from "./Table";

const useStyles = makeStyles(() => ({}));

const GameSessions = () => {
  const classes = useStyles();

  return (
    <Container>
      <h2>Player Sessions</h2>
      <SearchOptions />
      <PlayerSessionsTable />
    </Container>
  );
};

export default GameSessions;
